"use strict";
//from: inspections/components/checklist-layout/checklist-layout.html
angular.module("internal.exams").controller("InternalExamFormBuilder", ["$scope",
    "$state",
    "$stateParams",
    "EXForms",
    "FBForms",
    "FBFormTypes",
    "$q",
    function ($scope, $state, $stateParams, EXForms, FBForms, FBFormTypes, $q) {
        $scope.saving = false;
        $scope.formType = {};
        $scope.saving = false;
        $scope.resetting = false;
        $scope.loading = true;
        $scope.examinfo = {};
        $scope.formId = $stateParams.formID;
        $scope.parameters = {
            template_id: $stateParams.id,
            contentOptions: [{ id: 0, name: "Text Editor" }]
        };
        var promises = [];
        promises.push(FBFormTypes.getByCode("exam_form").then(function (formType) {
            $scope.formType = formType;
            if ($stateParams.formID == null) {
                $scope.form = {
                    name: "New Form",
                    form_type_id: formType.id,
                    the_form: {},
                    pages: [{
                        id: guid(),
                        name: "Page 1",
                        tab_active: true,
                        sort_order: 0,
                        sections: [{
                            id: guid(),
                            name: "Section 1",
                            sort_order: 0,
                            questions: []
                        }]
                    }]
                };
                $scope.masterForm = angular.copy($scope.form);
            }
        }));
        if ($stateParams.formID != null) {
            promises.push(FBForms.getByID($stateParams.formID).then(function (form) {
                if (form.pages.length > 0) {
                    form.pages[0].tab_active = true;
                }
                $scope.form = form;
                $scope.form.the_form = {};
                $scope.masterForm = angular.copy($scope.form);
            }));
        }
        $q.all(promises).then(function () {
            EXForms.getform($stateParams.id).then(function (formInfo) {
                $scope.examinfo = formInfo;
                $scope.form.name = $scope.examinfo.name;
            });
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });
        $scope.activePage = function () {
            for (var i = 0; i < $scope.form.pages.length; i++) {
                var page = $scope.form.pages[i];
                if (page.tab_active) {
                    return i;
                }
            }
            return 0;
        };
        $scope.save = function () {
            $scope.saving = true;
            $scope.oldActivePage = $scope.activePage();
            $scope.form.listOfSkills = [];
            // Loop through each page
            $scope.form.pages.forEach(function (page) {
                if (page.sections != null && page.sections.length > 0) {
                    // Loop through each section
                    page.sections.forEach(function (section) {
                        if (section.components != null && section.components.length > 0) {
                            // Loop through each component
                            section.components.forEach(function (component) {
                                if (component.component_type.code == 'exam_form_skill') {
                                    component.parameters.skill_question_ids = component.skill_question_ids;
                                    component.skill_question_ids.split(',').forEach(function (skillToadd) {
                                        $scope.form.listOfSkills.push(skillToadd);
                                    })
                                }
                                if (component.questions != null && component.questions.length > 0) {
                                    // Save non-empty questions
                                    component.questions = component.questions.filter(function (question) {
                                        return question.id !== undefined;
                                    });
                                }
                            });
                            // Save non-empty components again on the way back out
                            section.components = section.components.filter(function (component) {
                                if (component.id != undefined) {
                                    return (((component.component_type.code == "custom" || component.component_type.code == "dataset") && component.questions.length > 0) || (component.component_type.code != "custom" && component.component_type.code != "dataset" && component.component_type.code != null));
                                }
                            });
                        }
                    });
                    // Save non-empty sections again on the way back out
                    page.sections = page.sections.filter(function (section) {
                        return section.components.length > 0;
                    });
                }
            });
            $scope.form.fromExamForm = true;
            if (!isUndefined($scope.form.id)) {
                EXForms.getformCount($scope.form.id).then(function (formCount) {
                    if (formCount > 1) {
                        delete $scope.form["id"];
                    }
                    FBForms.save({ form: $scope.form, exam_form_id: $scope.formID }).then(function (form) {
                        if (form != null) {
                            EXForms.saveFormToExam($scope.formID, form.id).then(function () {
                                $state.go("internal.exams.administrative.form.builder", { id: $scope.formID, formID: form.id }, { reload: "internal.exams.administrative.form" });
                            });
                        }
                        $scope.saving = false;
                    });
                })
            } else {
                FBForms.save({
                    form: $scope.form,
                    exam_form_id: $scope.formID
                }).then(function (form) {
                    if (form != null) {
                        EXForms.saveFormToExam($scope.formID, form.id).then(function () {
                            $state.go("internal.exams.administrative.form.builder", { id: $scope.formID, formID: form.id }, { reload: "internal.exams.administrative.form" });
                        });
                    }
                    $scope.saving = false;
                });
            }
        };
        $scope.reset = function () {
            $scope.resetting = true;
            $scope.form = angular.copy($scope.masterForm);
            $scope.resetting = false;
        };
    }]);